const testimonials = [
  {
    id: 1,
    name: 'Robert A.',
    location: 'Camden, NJ',
    company: 'Camden Logistics LLC',
    rating: 5,
    text: "Garden State Roofing replaced our entire 12,000 sq ft flat roof on time and on budget. Their crew showed up every day, kept the site clean, and the finished TPO system has been completely leak-free through two NJ winters.",
    image: 'https://public.readdy.ai/ai/img_res/fd06054ba4b3458680c1eb0a052782b0.jpg',
  },
  {
    id: 2,
    name: 'Patricia V.',
    location: 'Cherry Hill, NJ',
    company: 'Cherry Hill Medical Plaza',
    rating: 5,
    text: "We had an emergency leak at 11pm on a Friday. Garden State answered immediately and had a crew on our roof within two hours. Incredibly responsive and professional. They fixed the issue and followed up the next week to do a full inspection.",
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20businesswoman%20in%20her%2040s%20with%20warm%20confident%20smile%2C%20soft%20neutral%20background%2C%20natural%20lighting%2C%20professional%20attire%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=t-nj-woman-2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Michael D.',
    location: 'Trenton, NJ',
    company: 'D&M Commercial Properties',
    rating: 5,
    text: "We manage 8 commercial properties across NJ and Garden State Roofing is the only crew we call. Their engineer-backed inspections have saved us from two major issues. Certified, reliable, and they do quality work every time.",
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20middle-aged%20property%20manager%20man%20with%20friendly%20expression%2C%20clean%20neutral%20background%2C%20natural%20lighting%2C%20casual%20business%20attire%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=t-nj-man-3&orientation=squarish',
  },
  {
    id: 4,
    name: 'Angela M.',
    location: 'Edison, NJ',
    company: 'Edison Retail Center',
    rating: 5,
    text: "From the initial estimate through project completion, every interaction with this team was professional and courteous. The EPDM roof they installed is GAF-certified and came with a fantastic warranty. Highly recommended for any NJ commercial property.",
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20friendly%20businesswoman%20in%20her%2050s%20with%20warm%20smile%2C%20light%20neutral%20background%2C%20natural%20lighting%2C%20professional%20business%20style%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=t-nj-woman-4&orientation=squarish',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-14">
          <p className="text-xs tracking-widest text-orange-500 uppercase mb-3">Client reviews</p>
          <h2 className="text-4xl md:text-5xl font-display font-black text-white tracking-tight">
            What Our Clients Say
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-black p-7 flex flex-col gap-5 hover:bg-gray-950 transition-colors">
              {/* Stars */}
              <div className="flex gap-0.5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-xs" />
                  </span>
                ))}
              </div>

              <p className="text-gray-400 text-sm leading-relaxed flex-1">&ldquo;{t.text}&rdquo;</p>

              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-gray-600">{t.company}</p>
                  <p className="text-xs text-gray-600">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-14 pt-10 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="text-white font-semibold text-lg mb-1">Ready to work with us?</p>
            <p className="text-gray-500 text-sm">Serving all of New Jersey &amp; Pennsylvania — call or get a free estimate.</p>
          </div>
          <a
            href="tel:8566776191"
            className="px-8 py-3.5 bg-orange-600 text-white text-sm font-semibold hover:bg-orange-500 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            (856) 677-6191
          </a>
        </div>
      </div>
    </section>
  );
}
